<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="boviclic-container">
  <div class="ibox">
    <div class="text-center justify-content-center">
      <img src="../../../assets/img/boviclic.jpg" alt="Boviclic">
    </div>

    <div class="ibox-head justify-content-center">
      <div class="ibox-title text-uppercase text-center" i18n="@@boviclicTitle">
        Removal request from Boviclic to validate
      </div>
    </div>

    <div class="ibox-body">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="alert alert-danger has-icon">
          <em class="fa fa-exclamation-triangle fa-3x alert-icon"></em>
          <h6>{{message}}</h6>
          <h6 *ngIf="!showContact" i18n="@@boviclicErrorContactIT">
            If the problem persists please contact the IT department.
          </h6>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mt-4" *ngIf="showContact">
        <app-display-contact></app-display-contact>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mt-4">
        <app-display-go-home></app-display-go-home>
      </div>
    </div>
  </div>
</div>
